(function () {
    'use strict';

    angular.module( APP_ID )
        .component( 'footerNavigation', {
            bindings: {
                navigationModel:     '<'
            },
            templateUrl:    'app/views/partials/layout/footer-navigation.html',
            controller:     FooterNavigationController,
            controllerAs:   'vm'
        });


    /**
     * @param {ng.IScope} $scope
     * @param {ContentSwitchingService} ContentSwitchingService
     * @param {Object} TEXTS
     */
    function FooterNavigationController(
        $scope,
        ContentSwitchingService,
        TEXTS
    ){

        /** @type {angular.IController} */
        var vm = this;





        /* ===== EXPOSE TO THE SCOPE ======================================== */


        $scope._ = TEXTS;





        /* ===== EXPOSE TO THE CONTROLLER =================================== */


        vm.$onChanges = function( changesObject ) {
            if ( changesObject.navigationModel && changesObject.navigationModel.currentValue ) {
                initNavigation();
                vm.$onChanges = function(){}; // Deregister event handler
            }
        };





        /* ===== PRIVATE FUNCTIONS ========================================== */


        function initNavigation() {
            vm.navigation = ContentSwitchingService.isInternational() ? vm.navigationModel.international : vm.navigationModel;

            // Make button for international same as a button for domestic
            vm.navigation.exploreButton = vm.navigationModel.exploreButton;
        }


    }


    FooterNavigationController.$inject = [ '$scope', 'ContentSwitchingService', 'TEXTS' ];
})();
